import { gsap } from "gsap";

export const initModals = () => {
	const modalEls = document.querySelectorAll(".theme-modal");
	if (!modalEls.length) return;

	initModalListeners(modalEls);
	initEscapeToClose();
};

const initModalListeners = (modals) => {
	modals.forEach((modal) => {
		const modalId = modal.id;
		if (!modalId) return;

		const trigger = document.querySelector(`[data-modal-target="${modalId}"]`);
		if (trigger) {
			trigger.addEventListener("click", () => openModal(modal));
		}

		closeButtonListener(modal);
		overlayListener(modal);
	});
};

const openModal = (modal) => {
	document.querySelectorAll(".theme-modal.is-open").forEach((openModalEl) => {
		closeModal(openModalEl, false);
	});

	modal.classList.add("is-open");

	const overlay = modal.querySelector(".overlay");
	const panel = modal.querySelector(".panel");

	if (overlay) {
		gsap.fromTo(overlay, { opacity: 0 }, { opacity: 1, duration: 0.2, ease: "power2.out" });
	}
	if (panel) {
		gsap.fromTo(panel, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.25, delay: 0.1, ease: "power2.out" });
	}
};

const closeModal = (modal, animate = true) => {
	if (!modal) return;

	const overlay = modal.querySelector(".overlay");
	const panel = modal.querySelector(".panel");

	const finalizeClose = () => {
		modal.classList.remove("is-open");
		stopEmbeddedMedia(modal);
	};

	if (!animate) {
		if (overlay) gsap.set(overlay, { opacity: 0 });
		if (panel) gsap.set(panel, { opacity: 0, y: 20 });
		finalizeClose();
		return;
	}

	if (overlay) {
		gsap.to(overlay, {
			opacity: 0,
			duration: 0.2,
			ease: "power2.in",
		});
	}

	if (panel) {
		gsap.to(panel, {
			opacity: 0,
			y: 20,
			duration: 0.2,
			ease: "power2.in",
			onComplete: finalizeClose,
		});
	} else {
		finalizeClose();
	}
};

const closeButtonListener = (modal) => {
	const closeButton = modal.querySelector(".close");
	if (!closeButton) return;

	closeButton.addEventListener("click", () => closeModal(modal, true));
};

const overlayListener = (modal) => {
	const overlay = modal.querySelector(".overlay");
	if (!overlay) return;

	overlay.addEventListener("click", () => closeModal(modal, true));
};

const initEscapeToClose = () => {
	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape") return;

		document.querySelectorAll(".theme-modal.is-open").forEach((modal) => {
			closeModal(modal, true);
		});
	});
};

const stopEmbeddedMedia = (modal) => {
	const iframes = modal.querySelectorAll("iframe");
	if (!iframes.length) return;

	iframes.forEach((iframe) => {
		const src = iframe.getAttribute("src");
		if (!src) return;

		iframe.setAttribute("src", src);
	});
};
